module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_01@2x-dfc6b8fa9fec77d39b96f85f5f86ce0d.webp";